import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";

export interface IReelLink {
    id: string;
    url: string;
    thumbnailUrl?: string | null;
    position: number;
    variantId: string;
    productId: string;
}

export interface ICreateReelMutationParameters {
    variantId: string;
    productId: string;
    url: string;
    thumbnailUrl?: string;
    position: number;
}

export const useCreateReel = (
    invalidQueryKeys: string | string[],
): UseMutationResult<IReelLink, unknown, ICreateReelMutationParameters> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<IReelLink, unknown, ICreateReelMutationParameters>({
        mutationFn: async (parameters: ICreateReelMutationParameters) => {
            if (!auth.token) {
                throw new Error("Cannot create reel without authorization token.");
            }

            return await api.Products.createReel({
                ...parameters,
                token: auth.token,
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
